import { useState } from 'react';
import VoteCard from './voteCard';
import Vote from './vote';
import Timer from '../features/timer';
let votes = require('../seeders/seedVotes.json');


function getCardInfo(){
    const PORT=3000
    const MONGO_URI="mongodb://localhost:27017/votes"
 }
 function generateVotes(){
   let vote_map = votes.map((vote,index) => {
      return (<VoteCard vote={vote} key={index} />)
   })
   return vote_map   
}


 function MeetingVote(props) {
    const [newMSG , setNewMSG] = useState()
    const now = new Date()
    let feed = [
        {
        user: "ajph03nix@gmail.com",
        timestamp: now.toISOString(),
        body:'first line of message test text.',  
        sent: false
        },
        {
        user: "ajph03nix@gmail.com",
        timestamp: now.toISOString(),
        body:'Second line of message test text. Not quite the first',  
        sent: false
        },
        {
        user: "ajphnx@gmail.com",
        timestamp: now.toISOString(),
        body:'Third line of message test text.',  
        sent: false
        },
    ]

     class MSG_OBJ {
        constructor(props){
            // super(props)
            this.state = { 
                user:JSON.parse(localStorage.getItem('cur_user')),
                timestamp: Date.now(),
                body:'',  
                sent: false 
             } 
             handleChange = handleChange.bind(this)
             submitText = submitText.bind(this)  
            }
            
        }
    function submitText(e){
        e.preventDefault()
        // e.target.value
        
        setNewMSG(true)
    }
    function handleChange(e){
        setNewMSG(false)
        let msg_obj
        e.preventDefault()
        if (newMSG){
            let msg_obj = new MSG_OBJ
        }else{ msg_obj = e.target.value}
        
    }
    function msgFeed(){
        
        let feed_map = feed.map((msg,index) => {
            return (
             <span className='msg_wrap'> <span className='msg_nm'>{msg.user}: </span><span className='msg_tstamp'>({msg.timestamp}) - </span><span className='msg_body'> &nbsp;{msg.body} </span></span>)
            })
            console.log('feed_map',feed_map)
            return feed_map   
    }

     return (

        <div>
             <h1 className="color-grad-blue-text">{props.view} vote</h1>
             <Vote  
                      user = {props.cur_user}
                      vote = {props.vote}
                      meetings = {props.meetings} 
                      votes = {votes} 
                      view = {props.view} 
                      setView = {props.setView}/>   
        </div>

        
  );
}
export default MeetingVote; 